import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errorMessage } from "../lib/api";
import { useAuth, homeFor } from "../lib/auth";
import { useLang } from "../lib/i18n";

export const OtpForm = ({ challengeId, onBack }) => {
  const { setUser } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/otp/verify", { challenge_id: challengeId, code });
      setUser(data);
      navigate(homeFor(data), { replace: true });
    } catch (err) { toast.error(errorMessage(err)); setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="w-full space-y-3" data-testid="otp-form">
      <p className="text-sm text-slate-600">{t("Enter the 6-digit code we emailed to you.")}</p>
      <input dir="ltr" inputMode="numeric" autoComplete="one-time-code" maxLength={6} required autoFocus value={code}
        onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} placeholder="••••••" aria-label={t("Code")} data-testid="otp-input"
        className="h-14 w-full rounded-2xl border border-slate-200 bg-white px-4 text-center font-mono text-2xl tracking-[0.5em] outline-none focus:border-slate-900" />
      <button type="submit" disabled={busy || code.length !== 6} data-testid="otp-submit"
        className="btn-press min-h-[52px] w-full rounded-2xl bg-slate-900 font-semibold text-white disabled:opacity-60">{t("Verify")}</button>
      {onBack && <button type="button" onClick={onBack} data-testid="otp-back" className="w-full text-sm font-semibold text-slate-500 hover:text-slate-900">{t("Back")}</button>}
    </form>
  );
};
